import useSettingsParams from 'hooks/useSettingsParams';

/** Видимість колонок звіту «Дохідність об'єктів» з параметрів компанії */
const useReportObjectsColumns = () => {
    const params = useSettingsParams();
    const showMaterials = Boolean(params.reportObjectsShowMaterials);
    const showServices = Boolean(params.reportObjectsShowServices);

    return {
        showMaterials,
        showServices,
        colCount: 4 + (showMaterials ? 1 : 0) + (showServices ? 1 : 0),
    };
};

export default useReportObjectsColumns;
